// extracted by mini-css-extract-plugin
export var typingIndicator = "_nk-0";